"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const custom_cell_style_1 = __importDefault(require("../custom-cell.style"));
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
function customLinkCell(arg) {
    return class CustomLinkCellClass extends react_1.default.Component {
        render() {
            const { dataItem, dataIndex, field } = this.props;
            return ((0, jsx_runtime_1.jsx)("td", Object.assign({ role: 'gridcell', style: this.props.style, colSpan: this.props.colSpan, "aria-selected": this.props.isSelected, "aria-colindex": this.props.ariaColumnIndex, className: this.props.className + ' k-command-cell' }, { [kendo_react_grid_1.GRID_COL_INDEX_ATTRIBUTE]: this.props.columnIndex }, { children: ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: arg.permission ? custom_cell_style_1.default.textLinkCell : {}, onClick: (e) => arg.permission ? arg.onClick(dataItem) : e.preventDefault() }, { children: field && dataItem[field] })) }, dataIndex)) })));
        }
    };
}
exports.default = customLinkCell;
